function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// 跨浏览器调用window.location方法

var _event = "useAllBrowserTabsLocation";
var _key = "AllBrowserTabsLocation";
function customUserEvent(value) {
  var event = new Event(_event);
  event.key = _key;
  event.newValue = value;
  window.dispatchEvent(event);
  localStorage.setItem(_key, JSON.stringify(value));
}
export var setAllBrowserTabsLocation = function setAllBrowserTabsLocation(data) {
  var newData = _objectSpread(_objectSpread({}, data), {}, {
    triggerKey: Math.random() + ""
  });
  customUserEvent(newData);
};
var listener = function listener(eventFn) {
  function _eventFn(e) {
    window.setTimeout(function () {
      eventFn(e.newValue, e);
    });
  }
  function storageFn(e) {
    window.setTimeout(function () {
      e.key === _key && e.newValue !== e.oldValue && eventFn(e.newValue && JSON.parse(e.newValue), e);
    });
  }
  //当前tab页有效
  window.addEventListener(_event, _eventFn);
  //非当前tab页有效
  window.addEventListener("storage", storageFn);
  return function () {
    window.removeEventListener(_event, _eventFn);
    window.removeEventListener("storage", storageFn);
  };
};
export var addAllBrowserTabsLocationListener = function addAllBrowserTabsLocationListener() {
  listener(function (data) {
    if (data.type === "replace") {
      window.location.replace(data.pathname);
    }
  });
};